module.exports = __webpack_public_path__ + "assets/images/alchemyb9113ea7.png";